export interface SegmentStructure {
  introEnabled: boolean
  closingEnabled: boolean
  /**
   * Key used for the closing segment. Defaults to "closing" — matches the
   * /v1/public/* backend (services/public_sessions.py:_build_segments).
   * The candidate flow (useInterview.ts) uses "outro" historically; it
   * passes that explicitly to keep its existing segment-key conventions
   * intact.
   */
  closingKey?: string
}

export function buildSegments(
  questionCount: number,
  structure: SegmentStructure = { introEnabled: true, closingEnabled: true },
): string[] {
  const segs: string[] = []
  if (structure.introEnabled) segs.push('intro')
  for (let i = 1; i <= questionCount; i++) segs.push(`q${i}`)
  if (structure.closingEnabled) segs.push(structure.closingKey ?? 'closing')
  return segs
}
